var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6DADF",
    d: "M11.24 13.268h57.34V87.81H11.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFC",
    d: "M77.181 16.135v63.074h-57.34V4.667h45.872z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.419 44.506)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#DA2346",
    cx: 13.857,
    cy: 13.857,
    r: 13.857
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.834 13.857 3.115-3.115a2.105 2.105 0 1 0-2.976-2.977l-3.116 3.115-3.115-3.115a2.105 2.105 0 1 0-2.977 2.977l3.115 3.115-3.115 3.116a2.105 2.105 0 1 0 2.977 2.976l3.115-3.115 3.116 3.115c.41.412.95.617 1.488.617a2.105 2.105 0 0 0 1.488-3.593l-3.115-3.116z",
    fill: "#FAF7F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.679 14.701H41.344a1.433 1.433 0 1 1 0-2.867h14.335a1.433 1.433 0 0 1 0 2.867z",
    fill: "#E7B6A1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6DADF",
    d: "M77.181 16.135H65.713V4.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.713 23.302h-28.67a1.433 1.433 0 0 1 0-2.867h28.67a1.433 1.433 0 1 1 0 2.867zM55.679 40.504H28.442a1.433 1.433 0 0 1 0-2.867H55.68a1.433 1.433 0 0 1 0 2.867zM44.21 31.903H28.443a1.433 1.433 0 0 1 0-2.867h15.769a1.433 1.433 0 0 1 0 2.867zM68.58 40.504h-7.167a1.433 1.433 0 0 1 0-2.867h7.167a1.433 1.433 0 0 1 0 2.867zM41.344 49.105H28.442a1.433 1.433 0 0 1 0-2.867h12.902a1.433 1.433 0 1 1 0 2.867zM37.043 57.706h-8.6a1.433 1.433 0 0 1 0-2.867h8.6a1.433 1.433 0 1 1 0 2.867zM38.477 66.307H28.442a1.433 1.433 0 0 1 0-2.867h10.035a1.433 1.433 0 0 1 0 2.867zM68.58 31.903H49.945a1.433 1.433 0 0 1 0-2.867H68.58a1.433 1.433 0 0 1 0 2.867z",
    fill: "#E7B6A1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.60836ec3443a574a1a7159caa0344f31.svg";
export { ForwardRef as ReactComponent };